import { PLATFORMS } from '@domain/platform';
import { ColorConstants } from '@shared/constants';

export const CAMPAIGN_NAME_FIELD_TEXTS = {
    TOTAL_ACCOUNT: 'Total',
};

export const CAMPAIGN_NAME_FIELD_TEST_IDS = {
    [PLATFORMS.GOOGLE_ADS.value]: 'campaign-google-icon-field',
    [PLATFORMS.FACEBOOK_ADS.value]: 'campaign-facebook-icon-field',
    CAMPAIGN_NAME: 'campaign-name-field',
    DEFAULT_CAMPAIGN_NAME: 'default-campaign-name-field',
};

export const ICON_COLORS_BY_PLATFORM = {
    [PLATFORMS.CLIENT.value]: {},
    [PLATFORMS.GOOGLE_ADS.value]: {
        primaryColor: ColorConstants.FUN_BLUE,
        secondaryColor: ColorConstants.FUN_ORANGE,
    },
    [PLATFORMS.FACEBOOK_ADS.value]: {
        primaryColor: ColorConstants.FUN_BLUE,
    },
};
